// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useCallback, useState} from 'react';
import Icon_up from '../img/svg/navig/up.svg';
import {Svg} from '../shared/svg';

interface i_use_expand_props {
    init_state?: boolean;
}
export const use_expand = (props:i_use_expand_props = {})=>{
    const {init_state = true} = props;
    const [expanded, set_expanded] = useState(init_state);
    const toggle = useCallback(()=>{
        set_expanded(s=>!s);
    }, []);
    // @ts-ignore
    const icon = <Icon_up width={16} height={16}/>;
    return {expanded, toggle, icon: <Svg icon={icon}/>};
};
